import { render, staticRenderFns } from "./BaiduMap.vue?vue&type=template&id=f2872832&scoped=true&"
import script from "./BaiduMap.vue?vue&type=script&lang=js&"
export * from "./BaiduMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2872832",
  null
  
)

export default component.exports